import { useState } from 'react';
import { EnrichmentPoint } from '../types';

const DataTable = ({ data, isDownload = false }: { data: EnrichmentPoint[]; isDownload?: boolean }) => {
  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 20;

  const totalPages = Math.ceil(data.length / itemsPerPage);

  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentItems = data.slice(indexOfFirstItem, indexOfLastItem);

  const title = isDownload ? 'Top Most Significant Results' : '';
  const containerClass = isDownload
    ? 'bg-gray-50 p-4 rounded-lg border border-gray-300'
    : 'bg-gray-50 p-4 rounded-lg border border-gray-300 mt-4';

  return (
    <div className={containerClass}>
      {title && <h3 className="text-lg font-bold text-gray-700 mb-4 text-center">{title}</h3>}
      <div className="overflow-x-auto">
        <table className="w-full text-sm border-collapse">
          <thead>
            <tr className="border-b-2 border-gray-400 bg-gray-100">
              <th className="text-left py-2 px-3 font-bold border-r border-gray-300">Disease/Phenotype</th>
              <th className="text-right py-2 px-3 font-bold border-r border-gray-300">p-value</th>
              <th className="text-right py-2 px-3 font-bold border-r border-gray-300">-log10(p)</th>
              <th className="text-right py-2 px-3 font-bold border-r border-gray-300">bgRatio</th>
              <th className="text-right py-2 px-3 font-bold">Intersection</th>
            </tr>
          </thead>
          <tbody>
            {currentItems.map((item, index) => (
              <tr
                key={item.id}
                className={`border-b border-gray-200 ${index % 2 === 0 ? 'bg-white' : 'bg-gray-50'}`}
              >
                <td className="py-2 px-3 text-left border-r border-gray-200">
                  <div className="flex items-center gap-3">
                    <div
                      className="w-4 h-4 rounded-full flex-shrink-0 border border-gray-400"
                      style={{ backgroundColor: item.color }}
                    ></div>
                    <span className="truncate max-w-[250px]" title={item.diseaseName}>
                      {item.diseaseName.length > 40
                        ? `${item.diseaseName.substring(0, 40)}...`
                        : item.diseaseName}
                    </span>
                  </div>
                </td>
                <td className="py-2 px-3 text-right font-mono border-r border-gray-200">
                  {Number(item.pvalue).toExponential(2)}
                </td>
                <td className="py-2 px-3 text-right font-mono border-r border-gray-200">
                  {(-Math.log10(item.pvalue)).toFixed(2)}
                </td>
                <td className="py-2 px-3 text-right font-mono border-r border-gray-200">
                  {isDownload ? Number(item.bgRatioNum).toFixed(4) : Number(item.bgRatioNum).toFixed(6)}
                </td>
                <td className="py-2 px-3 text-right font-mono">{item.intersectionSize}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      {/* Pagination */}
      {totalPages > 1 && (
        <div className="flex justify-center gap-2 mt-4">
          <button
            onClick={() => setCurrentPage((prev) => Math.max(prev - 1, 1))}
            disabled={currentPage === 1}
            className="px-3 py-1 bg-gray-200 rounded disabled:opacity-50"
          >
            Prev
          </button>

          <span className="px-2 py-1">
            {currentPage} / {totalPages}
          </span>

          <button
            onClick={() => setCurrentPage((prev) => Math.min(prev + 1, totalPages))}
            disabled={currentPage === totalPages}
            className="px-3 py-1 bg-gray-200 rounded disabled:opacity-50"
          >
            Next
          </button>
        </div>
      )}
    </div>
  );
};

export default DataTable;
